import { createSlice } from '@reduxjs/toolkit';
import { addNewCourseCategory, editCourseCategory, getAllCourseCategories } from './courseCategoriesService';

const initialState = {
  allCourseCategories: {
    isCourseCategoriesLoading: null,
    isCourseCategoriesSuccess: null,
    courseCategoriesMessage: null,
    pageCount: 0,
    courseCategories: [],
  },
  newCourseCategory: {
    isCourseCategoryCreating: null,
    isCourseCategoryCreated: null,
    courseCategoryCreationMsg: null,
  },

  editedCourseCategory: {
    isEditingCourseCategory: null,
    isCourseCategoryEdited: null,
    courseCategoryEditedMsg: null
  }
};

const courseCategoriesSlice = createSlice({
  name: 'courseCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCourseCategories.pending, (state) => {
        state.allCourseCategories = {
          ...initialState.allCourseCategories, // Reset to initial state
          isCourseCategoriesLoading: true,
          courseCategoriesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCourseCategories.rejected, (state, action) => {
        state.allCourseCategories = {
          ...initialState.allCourseCategories,
          isCourseCategoriesLoading: false,
          isCourseCategoriesSuccess: false,
          courseCategoriesMessage: action.payload || 'Error occurred while fetching courseCategories',
        };
      })

      // FULFILLED
      .addCase(getAllCourseCategories.fulfilled, (state, action) => {
        state.allCourseCategories = {
          ...initialState.allCourseCategories,
          isCourseCategoriesLoading: false,
          isCourseCategoriesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          courseCategories: action.payload || [],
        };
      });

    //CourseCategory creating
    builder
      .addCase(addNewCourseCategory.pending, (state) => {
        state.newCourseCategory = {
          ...initialState.newCourseCategory, // Reset to initial state
          isCourseCategoryCreating: true,
          courseCategoryCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewCourseCategory.rejected, (state, action) => {
        state.newCourseCategory = {
          ...initialState.newCourseCategory,
          isCourseCategoryCreating: false,
          isCourseCategoryCreated: false,
          courseCategoryCreationMsg: action.payload || 'Error occurred while creating the courseCategory.',
        };
      })

      // FULFILLED
      .addCase(addNewCourseCategory.fulfilled, (state, action) => {
        state.newCourseCategory = {
          ...initialState.newCourseCategory,
          isCourseCategoryCreating: false,
          isCourseCategoryCreated: true,
          courseCategoryCreationMsg: action.payload || 'Successfully created the courseCategory.',
        };
      });

    //CourseCategory editing
    builder
      .addCase(editCourseCategory.pending, (state) => {
        state.editedCourseCategory = {
          ...initialState.editedCourseCategory, // Reset to initial state
          isEditingCourseCategory: true,
          courseCategoryEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editCourseCategory.rejected, (state, action) => {
        state.editedCourseCategory = {
          ...initialState.editedCourseCategory, // Reset to initial state
          isEditingCourseCategory: false,
          isCourseCategoryEdited: false,
          courseCategoryEditedMsg: action.payload || 'Error occurred while editing the courseCategory.',
        };
      })

      // FULFILLED
      .addCase(editCourseCategory.fulfilled, (state, action) => {
        state.editedCourseCategory = {
          ...initialState.editedCourseCategory, // Reset to initial state
          isEditingCourseCategory: false,
          isCourseCategoryEdited: true,
          courseCategoryEditedMsg: action.payload || 'Successfully edited the courseCategory.',
        };
      });
  },
});

export default courseCategoriesSlice.reducer;
